import { useCallback, useContext } from "react";
import { AirPort, iChatData, iHotelInputPayload } from "../types";

import { StateContext } from "../context/globalContext/context";
import { iGlobalContext } from "../context/globalContext/interface";
import { extractBookingUpdateFromUrl } from "./extractBookingUpdateFromUrl";
import { handleRoomAllocation } from "../utils/handleRoomAllocation";

export function useFlightDataUpdate() {
  const state = useContext(StateContext);
  const { setBookingDetails, setSelectedChatData, setPromoCode, setFlightData }: iGlobalContext = state;
  const bookingFromUrl = extractBookingUpdateFromUrl(window.location.href);
  const handleUpdate = useCallback(
    (airportData: AirPort[]) => {
      setBookingDetails((prevDetails) => ({
        ...prevDetails,
        adultsCount: bookingFromUrl.adultsCount,
        childrenCount: bookingFromUrl.childrenCount,
        infantCount: bookingFromUrl.infantCount,
        seniorsCount: bookingFromUrl.seniorsCount,
        travelFromDate: "",
        flightClass: bookingFromUrl.flightClass,
        numberOfRoomCount: bookingFromUrl.numberOfRoomCount,
        tripType: bookingFromUrl.tripType,
        isThisMultiCityTrip: false,
        airlines: "",
        hotelChains: "",
        accommodationTypes: "",
        flightDayPart: "",
        numberOfStops: "",
        flightRefundable: null,
        flightPreferences: {
          connections: null,
          departureTime: [],
          refundable: null,
          airlines: [],
        },
        hotelPreferences: {
          refundable: null,
          hotelChains: [],
          accommodationTypes: [],
          userRatings: null,
          starRatings: [1],
        },
        visibleList: {
          flight: 0,
          hotel: 0,
          package: 2,
        },
        filters: {
          starRating: [],
        },
        airPort: airportData,
        // roomInfo: [
        //   {
        //     roomNo: 1,
        //     adults: 2,
        //     child: 0,
        //     childAges: "",
        //   },
        // ],
      }));
      setFlightData(null);
      setSelectedChatData({} as iChatData);
      // setOnBoardForm({ ...onBoardForm, signUpOffer: promoCode, isOfferAvailable: promoCode ? true : false });
      setPromoCode([]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setBookingDetails]
  );

  return handleUpdate;
}

export function useStayUpdate() {
  const state = useContext(StateContext);
  const { setBookingDetails, setSelectedChatData, setHotelData }: iGlobalContext = state;
  const bookingFromUrl = extractBookingUpdateFromUrl(window.location.href);
  const handleStayUpdate = useCallback(
    (hotelData: iHotelInputPayload[]) => {
      setBookingDetails((prevDetails) => ({
        ...prevDetails,
        adultsHotelCount: bookingFromUrl.adultsCount,
        childrenHotelCount: bookingFromUrl.childrenCount,
        infantHotelCount: bookingFromUrl.infantCount,
        seniorsCount: bookingFromUrl.seniorsCount,
        numberOfRoomCount: bookingFromUrl.numberOfRoomCount,
        tripType: bookingFromUrl.tripType,
        isThisMultiCityTrip: false,
        bookingParams: true,
        hotelPreferences: {
          refundable: null,
          hotelChains: [],
          accommodationTypes: [],
          userRatings: null,
          starRatings: [1],
        },
        visibleList: {
          flight: 0,
          hotel: 0,
          package: 2,
        },
        filters: {
          starRating: [],
        },
        hotels: hotelData,

        roomInfo: handleRoomAllocation(
          bookingFromUrl.adultsCount,
          bookingFromUrl.childrenCount,
          bookingFromUrl.infantCount,
          bookingFromUrl.seniorsCount,
          bookingFromUrl.numberOfRoomCount,
          (bookingFromUrl as any).childrenAges
        ),
      }));
      setHotelData(null);
      setSelectedChatData({} as iChatData);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setBookingDetails]
  );

  return handleStayUpdate;
}
